module.exports = __webpack_public_path__ + "static/media/RONELLE.de908605.jpg";